<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { AlternativeEditorAttributeFieldReadModel } from "@Alternatives/Alternatives/Domain/readmodels";
    import { ValidationError } from "@common/types";
    import { formatStringForDateInput } from "@common/Common";

    @Component({
        props: {
            propF: { type: Object, required: true },
            propErrors: { type: Array, required: true },
        },
        watch: {
            value: 'onValueChanged'
        }
    })
    export default class DateListSingleValue extends Vue
    {
        get f(): AlternativeEditorAttributeFieldReadModel { return this.$props.propF as AlternativeEditorAttributeFieldReadModel; }
        get errors(): ValidationError[] { return this.$props.propErrors as ValidationError[]; }

        get error() { return this.errors?.find(error => error.Context.startsWith(`AlternativeAttribute:${this.f.Id}`))?.Error; }

        definedValues: DefinedValueViewModel[] | null = null;
        value: string | null = null;

        //@Watch('value')
        onValueChanged(newValue: string)
        {
            this.f.Value = newValue;
        }

        mounted()
        {
            this.value = formatStringForDateInput(this.f.Value);
            this.definedValues = this.f.DefinedValues.map(dv => new DefinedValueViewModel(dv.Value, dv.Label));
        }
    }

    class DefinedValueViewModel
    {
        Value: string = null;
        Label: string = null;

        constructor(value: any, label: string)
        {
            this.Value = formatStringForDateInput(value);
            this.Label = label;
        }
    }

</script>

<template>
    <div class="form-group">
        <label>
            <span v-if="f.IsRequired" style="color: red;">*</span> {{f.Name}}
        </label>
        <select v-model="value" class="form-control" :required="f.IsRequired" :disabled="f.IsReadonly">
            <option :value="null">Choose...</option>
            <option v-for="dv in definedValues" :value="dv.Value">{{dv.Label}}</option>
        </select>
        <div class="error">{{error}}</div>
        <small class="form-text text-muted" v-if="f.Description">{{f.Description}}</small>
    </div>
</template>